import { render, staticRenderFns } from "./Competencias.vue?vue&type=template&id=17ecf022"
import script from "./Competencias.vue?vue&type=script&lang=js"
export * from "./Competencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports